import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { INotificationEntity } from '../../Stores/NotificationsStore'
import NotificationsStore from '../../Stores/NotificationsStore'
import LocalizationStore from '../../Stores/LocalizationStore'

interface INotificationsProps {
    localizationStore?: LocalizationStore
}

@inject('localizationStore')

@observer
export default class NotificationsView extends React.Component<INotificationsProps> {
    
    constructor(props: INotificationsProps) {
        super(props)
    }
    
    handleDismiss(alertIndex: Number): void {
        const ns = NotificationsStore.getInstance()
        ns.removeAlert(alertIndex)
    }

    render() {
        const self = this

        const ns = NotificationsStore.getInstance()
        let list = ns.getList()

        return (
            <div className="alerts">
                { list.map(function (item: INotificationEntity, i: number) {
                    return <div role="alert" className={'alert alert-' + item.type} key={i}>
                        <button type="button" className="close" onClick={() => self.handleDismiss(i)}>
                            <span aria-hidden="false">×</span>
                        </button>
                        <h4>{item.message}</h4>
                    </div>
                    })
                }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/NotificationsView.tsx